import { Box, Flex, Heading, Input } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { PlaceDetailsCompat } from '../../../hooks'

export interface WhereAreYouHouseHuntingProps {
  onPlaceSelected: (place: any, placeDetails?: PlaceDetailsCompat | null) => void
  setShowGooglePlaceSelector: (show: boolean) => void
}

const MSG = defineMessages({
  title: {
    id: 'ForYouContent.WhereAreYouHouseHunting.title',
    defaultMessage: 'Search for homes'
  },
  placeholder: {
    id: 'ForYouContent.WhereAreYouHouseHunting.placeholder',
    defaultMessage: 'Enter a place...'
  },
  enterAPlace: {
    id: 'ForYouContent.WhereAreYouHouseHunting.enterAPlace',
    defaultMessage: 'Enter a place...'
  }
})

export const WhereAreYouHouseHunting = ({ setShowGooglePlaceSelector }: WhereAreYouHouseHuntingProps) => {
  const intl = useIntl()

  return (
    <Box
      // @ts-ignore - custom gradient and border styles
      background='radial-gradient(79.74% 50.73% at 75.36% 100%, rgba(255, 52, 142, 0.20) 0%, rgba(255, 52, 142, 0.00) 100%), linear-gradient(71deg, #26143D 25.8%, #4A186B 99.21%)'
      border='1px solid #AB24E5'
      borderRadius='16px'
      p={{ base: 6, md: 8 }}
      mb={8}
    >
      <Flex flexDirection='column'>
        <Heading textAlign={['center', 'left']} size='xl' mb={6} color='white' fontWeight='bold'>
          {intl.formatMessage(MSG.title)}
        </Heading>

        <Box w='100%'>
          <Input
            name={intl.formatMessage(MSG.enterAPlace)}
            placeholder={intl.formatMessage(MSG.placeholder)}
            onClick={() => setShowGooglePlaceSelector(true)}
            // @ts-ignore - custom rgba colors not in design system
            backgroundColor='rgba(255, 255, 255, 0.1)'
            border='1px solid rgba(255, 255, 255, 0.2)'
            borderRadius='12px'
            color='white'
            _placeholder={{ color: 'rgba(255, 255, 255, 0.7)' }}
            _hover={{ backgroundColor: 'rgba(255, 255, 255, 0.15)' }}
            _focus={{ backgroundColor: 'rgba(255, 255, 255, 0.15)', borderColor: '#AB24E5' }}
            py={6}
            px={4}
            fontSize='md'
          />
        </Box>
      </Flex>
    </Box>
  )
}
